import React from 'react';
import './Skeleton.css';

function SkeletonCharts({type}) {

    return (
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}}  >
            <i className={`chart fas ${type}`} />
        </div>
        )

}

export default SkeletonCharts